<script setup lang="ts">
import type { BagAllowance } from '@optionway/models';

const properties = defineProps<{ bagAllowances: BagAllowance[]; loading?: boolean }>();
</script>

<template>
  <template v-if="properties.loading">
    <div
      v-for="i in 3"
      :key="i"
      class="flex items-center"
    >
      <UiSkeleton class="h-10 w-full" />
    </div>
  </template>
  <template v-else>
    <div
      v-if="properties.bagAllowances.length === 0"
      class="flex items-center"
    >
      <UiCustomBagAllowancesLuggageDescription
        type="CHECKED"
        bookable-by="LEG"
        source="FARE"
        :pieces="0"
      />
    </div>
    <div
      v-for="(bag, i) in properties.bagAllowances"
      :key="`${bag.type}-${i}`"
      class="flex items-center"
    >
      <UiCustomBagAllowancesLuggageDescription v-bind="bag" />
    </div>
  </template>
</template>
